import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ItinerariosComponent } from './itinerarios.component';
import { ItinerarioDetalleComponent } from './detail/itinerario-detalle.component';

const routes: Routes = [
  {
    path: '',
    component: ItinerariosComponent
  },
  {
    path: ':id',
    component: ItinerarioDetalleComponent,
    data: {
      title: 'Detalle de Itinerario'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ItinerariosRoutingModule { }
